import { createContext } from 'react';
import { FLEX_WINDOW_KEY, FLEX_WINDOW_GLOBAL_CONTEXTS_KEY } from './windowFlex.mjs';

const createGlobalReferenceContext = (key, initialValue) => {
  if (typeof window === "undefined") {
    return createContext(initialValue);
  }
  if (window?.[FLEX_WINDOW_KEY]?.[FLEX_WINDOW_GLOBAL_CONTEXTS_KEY] === void 0) {
    window[FLEX_WINDOW_KEY] = {
      ...window?.[FLEX_WINDOW_KEY] || {},
      [FLEX_WINDOW_GLOBAL_CONTEXTS_KEY]: {}
    };
  }
  const globalContexts = window?.[FLEX_WINDOW_KEY]?.[FLEX_WINDOW_GLOBAL_CONTEXTS_KEY] ?? {};
  return globalContexts?.[key] ?? (globalContexts[key] = createContext(initialValue));
};

export { createGlobalReferenceContext };
//# sourceMappingURL=createGlobalReferenceContext.mjs.map
